import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useHistory } from "react-router-dom";

export default function P230Search({ data, searchData }) {
    const history = useHistory();

    return (
        <div className="p-fluid p-formgrid p-grid">
            <div className="p-field p-col-12 p-md-4">
                <label>เลขที่สัญญา</label>
                <InputText type="text" placeholder="เลขที่สัญญา" disabled value={data.contractNo} />
            </div>
            <div className="p-field p-col-12 p-md-4">
                <label>เส้นทาง</label>
                <InputText type="text" placeholder="เส้นทาง" disabled value={searchData.routeName} />
            </div>
            <div className="p-field p-col-12 p-md-2">
                <div style={{ display: "flex", marginBottom: "10px" }}>
                    <Button className="p-button-secondary p-button btn-srh-responsive" icon="pi pi-arrow-left" style={{ width: 150 }} label="กลับหน้าจอหลัก" onClick={() => history.push("/208")} />
                </div>
            </div>
        </div>
    );
}
